// extracted by mini-css-extract-plugin
export default {"contentMain":"Swagger_contentMain__Oi5y1","appBar":"Swagger_appBar__YOzS7","waiting":"Swagger_waiting__FcjuQ","swaggerContent":"Swagger_swaggerContent__ljfMN"};